"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.isSupportedComponent = isSupportedComponent;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _TextComponent = _interopRequireDefault(require("./TextComponent"));

var _ArticleComponent = _interopRequireDefault(require("./ArticleComponent"));

var _ButtonComponent = _interopRequireDefault(require("./ButtonComponent"));

var _FormComponent = _interopRequireDefault(require("./FormComponent"));

var _DynamicCardComponent = _interopRequireDefault(require("./DynamicCardComponent"));

var _EscalationBanner = _interopRequireDefault(require("./EscalationBanner"));

var SUPPORTED_TYPES = new Set(['text', 'article', 'button', 'form', 'dynamic_card', 'image', 'embed', 'zendesk_handoff', 'salesforce_handoff', 'zendesk_ticket_creation']);

function isSupportedComponent(component) {
  if (!component || (0, _typeof2.default)(component) !== 'object') return false;
  var type = component.type;
  return typeof type === 'string' && SUPPORTED_TYPES.has(type);
} // Set of widget component types we've already warned about, to avoid log spam
// when an unknown type appears many times in a single response.


var warnedUnknownTypes = new Set();

function warnUnknownType(component) {
  var _type;

  var type = component && (0, _typeof2.default)(component) === 'object' && 'type' in component ? String((_type = component.type) !== null && _type !== void 0 ? _type : 'unknown') : 'unknown';
  if (warnedUnknownTypes.has(type)) return;
  warnedUnknownTypes.add(type);
  console.warn("[Forethought] Unsupported widget component type: ".concat(type), component);
}

var WidgetComponentRenderer = function WidgetComponentRenderer(_ref) {
  var component = _ref.component,
      disabled = _ref.disabled,
      onButtonSelect = _ref.onButtonSelect,
      onFormSubmit = _ref.onFormSubmit;

  if (!component || (0, _typeof2.default)(component) !== 'object' || !('type' in component)) {
    warnUnknownType(component);
    return null;
  }

  switch (component.type) {
    case 'text':
      return (0, _preact.h)(_TextComponent.default, {
        component: component
      });

    case 'article':
      return (0, _preact.h)(_ArticleComponent.default, {
        component: component
      });

    case 'button':
      return (0, _preact.h)(_ButtonComponent.default, {
        component: component,
        disabled: disabled,
        onSelect: onButtonSelect
      });

    case 'form':
      return (0, _preact.h)(_FormComponent.default, {
        component: component,
        disabled: disabled,
        onSubmit: onFormSubmit
      });

    case 'dynamic_card':
      return (0, _preact.h)(_DynamicCardComponent.default, {
        component: component,
        disabled: disabled,
        onSelect: onButtonSelect
      });

    case 'image':
      return (0, _preact.h)("div", {
        className: "forethought-agent__images"
      }, component.images.map(function (img) {
        return (0, _preact.h)("img", {
          key: img.url,
          src: (0, _absoluteUrlRuntime.resolveUrl)(img.url),
          alt: img.description
        });
      }));

    case 'embed':
      return (0, _preact.h)("div", {
        className: "forethought-agent__embed"
      }, (0, _preact.h)("iframe", {
        src: (0, _absoluteUrlRuntime.resolveUrl)(component.embed_url),
        title: "embedded content",
        allowFullScreen: true
      }));

    case 'zendesk_handoff':
    case 'salesforce_handoff':
    case 'zendesk_ticket_creation':
      return (0, _preact.h)(_EscalationBanner.default, {
        component: component
      });

    default:
      warnUnknownType(component);
      return null;
  }
};

var _default = WidgetComponentRenderer;
exports.default = _default;